import {
  createRoutesFromChildren,
  matchRoutes,
  Routes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';
import {
  createReactRouterV6Options,
  getWebInstrumentations,
  initializeFaro,
  ReactIntegration,
} from '@grafana/faro-react';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';

export let faroInstance: ReturnType<typeof initializeFaro> | null = null;

/**
 * Initialize Grafana Faro for Real User Monitoring (RUM)
 * Includes web instrumentations, tracing, React Router integration, and session tracking
 */
export function initFaro() {
  // Skip initialization if explicitly disabled via env var
  if (process.env.REACT_APP_DISABLE_FARO === 'true') {
    console.log('[Faro] Initialization disabled via REACT_APP_DISABLE_FARO');
    return null;
  }

  try {
    // Use Grafana Cloud collector URL
    const collectorUrl =
      process.env.REACT_APP_FARO_URL ||
      'https://faro-collector-prod-eu-central-0.grafana.net/collect/b68620d5d91281245a2dde48f4bad8c6';

    faroInstance = initializeFaro({
      url: collectorUrl,
      app: {
        name: 'app_agent',
        version: process.env.REACT_APP_VERSION || '1.0.0',
        environment: process.env.NODE_ENV === 'production' ? 'production' : 'development',
      },
      sessionTracking: {
        samplingRate: 1,
        persistent: true,
      },
      instrumentations: [
        // Mandatory, omits default instrumentations otherwise.
        ...getWebInstrumentations({
          captureConsole: true,
        }),

        // Tracing package to get end-to-end visibility for HTTP requests.
        new TracingInstrumentation(),

        // React integration for React Router 6 applications.
        new ReactIntegration({
          router: createReactRouterV6Options({
            createRoutesFromChildren,
            matchRoutes,
            Routes,
            useLocation,
            useNavigationType,
          }),
        }),
      ],
    });

    console.log('[Faro] Successfully initialized');
    return faroInstance;
  } catch (error) {
    console.error('[Faro] Failed to initialize:', error);
    return null;
  }
}
